import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { FeaturedRail } from '@Components/AbwaabPlus'
import { useGetFeaturedBundlesQuery } from '@Features/Bundle/BundleApi/BundleApi'
import BundleCard from '@Features/Bundle/Components/BundleCard'
import usePlatformFlags from '@Hooks/usePlatformFlags'

/**
 * The admin-curated featured-bundles carousel — mirror of the featured-courses
 * rail (the featured endpoint is public). Self-hiding: renders nothing when
 * the bundles flag is off or nothing is featured, so each landing can mount
 * it unconditionally.
 */
const FeaturedBundlesCarousel: React.FC = () => {
	const [t] = useTranslation('bundle')
	const { bundlesEnabled } = usePlatformFlags()
	const navigate = useNavigate()

	const { data, isLoading, isFetching } = useGetFeaturedBundlesQuery(undefined, { skip: !bundlesEnabled })
	const loading = isLoading || isFetching
	/* Same ordering rule as the featured-courses rail — see the note there. */
	const bundles = React.useMemo(() => {
		const rows = data?.data ?? []
		return [...rows].sort((a, b) => (a.featured_order ?? Number.MAX_SAFE_INTEGER) - (b.featured_order ?? Number.MAX_SAFE_INTEGER))
	}, [data?.data])

	if (!bundlesEnabled) return null
	if (!loading && bundles.length === 0) return null

	return (
		<FeaturedRail
			title={t('featured_title', { defaultValue: 'باقات مختارة' })}
			seeAllLabel={t('see_all', { defaultValue: 'عرض الكل' })}
			onSeeAll={() => navigate('/search?tab=bundles')}
			loading={loading}
		>
			{bundles.map(bundle => (
				<BundleCard key={`featured-${bundle.id}`} bundle={bundle} />
			))}
		</FeaturedRail>
	)
}

export default FeaturedBundlesCarousel
